export default defineI18nConfig(() => ({
    fallbackLocale: 'de',
    datetimeFormats: {
        'de': {
            dateNumericShort: {
                year: '2-digit', month: '2-digit', day: '2-digit'
            },
            dateNumeric: {
                year: 'numeric', month: '2-digit', day: '2-digit'
            },
            dateShort: {
                year: 'numeric', month: 'short', day: 'numeric'
            },
            dateTimeNumericShort: {
                year: '2-digit', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric'
            },
            dateTimeShort: {
                year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
            },
            dateLong: {
                year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'
            },
            dateWithWeekday: {
                weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit'
            },
            dateTimeWithWeekday: {
                weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
            },
            timeShort: {
                hour: 'numeric', minute: 'numeric'
            }
        },
        'en': {
            dateShort: {
                year: 'numeric', month: 'short', day: 'numeric'
            },
            dateTimeShort: {
                year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
            },
        }
    }
}))